<template>
  <div>
    <v-card class="main">
      <v-toolbar class="elevation-2" dense>
        <v-toolbar-title class="body-2 beez-bold">
          Task Maintenance
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-card class="pb-2" flat style="border-radius: 5px">
          <v-toolbar class="body-2 beez-bold " dense flat>
            Select By Tasks in progress
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                flat
                icon
                @click="showTasksInProgress = !showTasksInProgress"
              >
                <v-icon
                  >{{ showTasksInProgress ? 'expand_less' : 'expand_more' }}
                </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form
            v-show="showTasksInProgress"
            ref="taskInProgress"
            v-model="valid"
            :class="$vuetify.dark ? 'card-dark pa-2' : 'card-light pa-2'"
            lazy-validation
          >
            <v-btn
              class="primary text-capitalize"
              flat
              :loading="taskLoader"
              @click="getTasksInProgress"
            >
              Get Tasks In-progress
            </v-btn>
            <v-progress-linear
              :active="taskLoader"
              indeterminate
            ></v-progress-linear>
            <v-chip class="mx-2" color="secondary" outline
              ><span style="font-size: 1.1em;"
                >Total Items: {{ totalTasksInProgress }}</span
              ></v-chip
            >
            <v-card
              :class="$vuetify.dark ? 'card-dark pa-1' : 'card-light pa-1'"
              flat
              style="border-radius: 10px"
            >
              <v-pagination
                v-model="pageInProgress"
                :length="pageCountInProgress"
                :total-visible="7"
              ></v-pagination>
              <template v-for="(task, taskIndex) in items">
                <task-card
                  :key="taskIndex + 'admin-task-card-item'"
                  :selected-task-id="selectedTaskId"
                  :task-action="false"
                  :task-id="task.id"
                  :task-number="taskIndex"
                  task-view="admin"
                  @task-refresh="refresh"
                  @task-selected="setSelectedTask"
                />
              </template>
            </v-card>
          </v-form>
        </v-card>
        <v-card class="pb-2" flat style="border-radius: 5px">
          <v-toolbar class="body-2 beez-bold " dense flat>
            Select By Task Id
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn flat icon @click="showTaskByIdForm = !showTaskByIdForm">
                <v-icon
                  >{{ showTaskByIdForm ? 'expand_less' : 'expand_more' }}
                </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form
            v-show="showTaskByIdForm"
            ref="taskByIdForm"
            v-model="valid"
            :class="$vuetify.dark ? 'card-dark pa-2' : 'card-light pa-2'"
            lazy-validation
          >
            <v-text-field
              v-model="taskId"
              :counter="36"
              :rules="taskIdRules"
              clearable
              label="Task Id"
              outline
              placeholder="example: 123e4567-e89b-12d3-a456-426614174000"
              required
            ></v-text-field>

            <v-btn
              :disabled="!valid"
              class="primary text-capitalize"
              flat
              @click="getTasks"
              :loading="taskLoader"
            >
              Get Task
            </v-btn>

            <v-btn class="text-capitalize" flat outline @click="reset">
              Reset
            </v-btn>

            <v-btn
              class="text-capitalize"
              flat
              outline
              @click="resetValidation"
            >
              Reset Validation
            </v-btn>
            <v-progress-linear
              :active="taskLoader"
              indeterminate
            ></v-progress-linear>
            <task-card
              v-if="items.length > 0"
              :selected-task-id="selectedTaskId"
              :task-action="false"
              :task-id="items[0].id"
              :task-number="0"
              task-view="admin"
              @task-refresh="refresh"
              @task-selected="setSelectedTask"
            />
          </v-form>
        </v-card>
        <v-card flat style="border-radius: 5px">
          <v-toolbar class="body-2 beez-bold " dense flat>
            Select By Task properties
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                flat
                icon
                @click="showTaskByPropsForm = !showTaskByPropsForm"
              >
                <v-icon
                  >{{ showTaskByPropsForm ? 'expand_less' : 'expand_more' }}
                </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form
            v-show="showTaskByPropsForm"
            ref="taskByPropsForm"
            v-model="validPropsForm"
            :class="
              $vuetify.dark ? 'card-dark mb-2 pa-2' : 'card-light mb-2 pa-2'
            "
            lazy-validation
          >
            <v-text-field
              v-model="taskName"
              :rules="taskNameRules"
              clearable
              label="Task Name"
              outline
              placeholder="Task Name as provided in the Workflow"
            ></v-text-field>
            <v-text-field
              v-model="assignee"
              :disabled="unassigned"
              :rules="assigneeRules"
              clearable
              label="Tasks Assigned To"
              outline
              placeholder="User name (Email Id in an Email address) ex: 'name' for name@domain.com"
            ></v-text-field>
            <v-text-field
              v-model="candidateUser"
              :rules="assigneeRules"
              clearable
              label="Tasks that can be assigned to"
              outline
              placeholder="User name (Email Id in an Email address) ex: 'name' for name@domain.com"
            ></v-text-field>
            <v-text-field
              v-model="candidateGroup"
              :rules="assigneeRules"
              clearable
              label="Tasks assigned To Group"
              outline
              placeholder="Group name as provided in the Workflow/Rule"
            ></v-text-field>
            <v-text-field
              v-model="owner"
              :rules="assigneeRules"
              clearable
              label="Tasks under the ownership of"
              outline
              placeholder="User name (Email Id in an Email address) ex: 'name' for name@domain.com"
            ></v-text-field>
            <v-checkbox
              v-model="unassigned"
              label="Unassigned Tasks"
            ></v-checkbox>

            <v-btn
              :disabled="!validPropsForm"
              class="primary text-capitalize"
              flat
              :loading="taskLoader"
              @click="getTasks"
            >
              Get Tasks
            </v-btn>

            <v-btn class="text-capitalize" flat outline @click="reset">
              Reset Form
            </v-btn>

            <v-btn
              class="text-capitalize"
              flat
              outline
              @click="resetValidation"
            >
              Reset Validation
            </v-btn>

            <v-progress-linear
              :active="taskLoader"
              indeterminate
            ></v-progress-linear>
            <v-chip class="mx-2" color="secondary" outline
              ><span style="font-size: 1.1em;"
                >Total Items: {{ totalTasks }}</span
              ></v-chip
            >
            <v-card
              :class="$vuetify.dark ? 'card-dark pa-1' : 'card-light pa-1'"
              flat
              style="border-radius: 10px"
            >
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="7"
              ></v-pagination>
              <template v-for="(task, taskIndex) in items">
                <task-card
                  :key="taskIndex + 'admin-task-card-item'"
                  :selected-task-id="selectedTaskId"
                  :task-action="false"
                  :task-id="task.id"
                  :task-number="taskIndex"
                  task-view="admin"
                  @task-refresh="refresh"
                  @task-selected="setSelectedTask"
                />
              </template>
            </v-card>
          </v-form>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import TaskCard from './TaskCard'

export default {
  name: 'TaskMaintenance',
  components: { TaskCard },
  data: () => {
    return {
      page: 1,
      pageInProgress: 1,
      pageCount: 0,
      pageCountInProgress: 0,
      totalTasks: 0,
      totalTasksInProgress: 0,
      valid: true,
      validPropsForm: true,
      selectedTaskId: null,
      showTaskByIdForm: false,
      showTasksInProgress: false,
      showTaskByPropsForm: false,
      unassigned: false,
      items: [],
      taskLoader: false,
      taskName: '',
      assignee: '',
      owner: '',
      candidateUser: '',
      candidateGroup: '',
      taskNameRules: [
        v =>
          (v && v.length > 2) || 'Task name should be a minimum of 2 characters'
      ],
      assigneeRules: [
        v =>
          (v && _.isArray(v.toString().match('^[a-zA-Z0-9]+$'))) ||
          'Does not look like a valid name!'
      ],
      taskIdRules: [
        v => !!v || 'Task Id is required',
        v =>
          (v && v.length === 36) ||
          'Task Id should be a UUID of length 36 characters',
        v =>
          (v &&
            _.isArray(
              v
                .toString()
                .match(
                  '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}'
                )
            )) ||
          'Task Id should be a UUID'
      ],
      taskId: ''
    }
  },
  computed: {
    ...mapState({
      taskForMaintenance: state => state.tasks.taskForMaintenance
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  watch: {
    taskForMaintenance() {
      this.items = this.taskForMaintenance
    },
    page() {
      this.getTasks()
    },
    pageInProgress() {
      this.getTasksInProgress()
    },
    showTaskByIdForm() {
      if (this.showTaskByIdForm) {
        this.showTasksInProgress = false
        this.showTaskByPropsForm = false
        this.getTasks()
      }
    },
    showTasksInProgress() {
      if (this.showTasksInProgress) {
        this.showTaskByIdForm = false
        this.showTaskByPropsForm = false
        this.getTasksInProgress()
      }
    },
    showTaskByPropsForm() {
      if (this.showTaskByPropsForm) {
        this.showTasksInProgress = false
        this.showTaskByIdForm = false
        this.getTasks()
      }
    }
  },
  created() {
    this.items = this.taskForMaintenance
  },
  methods: {
    setSelectedTask(taskId) {
      this.selectedTaskId = taskId
    },
    validate() {
      if (this.$refs.taskByIdForm.validate()) {
        this.snackbar = true
      }
    },
    refresh() {
      this.getTasks()
    },
    reset() {
      this.$refs.taskByIdForm.reset()
      this.$refs.taskByPropsForm.reset()
    },
    resetValidation() {
      this.$refs.taskByIdForm.resetValidation()
      this.$refs.taskByPropsForm.resetValidation()
    },
    async getTasksInProgress() {
      this.taskLoader = true
      try {
        let urlParams = `&page=${this.pageInProgress}&size=10`
        this.totalTasksInProgress = await this.$store.dispatch(
          'fetchTasksInProgress',
          urlParams
        )
        this.pageCountInProgress = Math.ceil(this.totalTasksInProgress / 10)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to fetch User Tasks in progress',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskLoader = false
    },
    async getTasks() {
      this.taskLoader = true
      this.selectedTaskId = null
      try {
        let params = ''
        this.items = []
        if (this.taskId) {
          await this.$store.dispatch('fetchTaskForAdmin', this.taskId)
        } else if (this.showTaskByPropsForm) {
          params = params + `&maxResults=10&firstResult=${(this.page - 1) * 10}`
          if (this.taskName) params = `&name=${this.taskName}`
          if (this.assignee) {
            if (params.length === 0) {
              params = `assignee=${this.assignee}`
            } else {
              params = params + `&assignee=${this.assignee}`
            }
          }
          if (this.candidateUser) {
            if (params.length === 0) {
              params = `candidateUser=${this.candidateUser}`
            } else {
              params = params + `&candidateUser=${this.candidateUser}`
            }
          }
          if (this.candidateGroup) {
            if (params.length === 0) {
              params = `candidateGroup=${this.candidateGroup}`
            } else {
              params = params + `&candidateGroup=${this.candidateGroup}`
            }
          }
          if (this.owner) {
            if (params.length === 0) {
              params = `owner=${this.owner}`
            } else {
              params = params + `&owner=${this.owner}`
            }
          }
          if (this.unassigned) {
            if (params.length === 0) {
              params = `unassigned=true`
            } else {
              params = params + `&unassigned=true`
            }
          }
          this.totalTasks = await this.$store.dispatch(
            'fetchTasksCountForAdmin',
            params
          )
          this.pageCount = Math.ceil(this.totalTasks / 10)
          await this.$store.dispatch('fetchTasksForAdmin', params)
        }
      } catch (e) {
        if (e.response.data.status === 404) {
          await this.$store.dispatch('directNotification', {
            type: 'warning',
            message: 'Task not Found',
            description:
              'Task not valid or is already complete., Only open tasks can be fetched',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } else {
          await this.$store.dispatch('directNotification', {
            message: 'Unable to fetch User Tasks',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            type: 'error',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      }
      this.taskLoader = false
    }
  }
}
</script>

<style scoped></style>
